export enum MaritalStatusEnum {
  single = 'S',
  married = 'M',
  windowed = 'W',
  divorced = 'D',
}
